import { ObjectKeys } from './objectKeys';

export type KeysOfUnion<T extends object> = T extends T ? ObjectKeys<T> : never;

/**
A strongly-typed version of `Object.keys()` that works with `union` types only
For simple object types please use `objectKeys` utility!

How it differs from `objectKeys` utility => See the example below.
Doesn't work with numeric keys, so please don't use numeric enums

Stay alert and use it with caution! [See more in explanation]
This is useful ONLY for object literals since `Object.keys()` always returns an array of strings. 

Short explanation:
It makes sense only in the domain of type variables (i.e. T and keyof T). Once you move to the instantiated type world 
it degenerates because an object can (and often does) have more properties at run-time than are statically known at compile time

- [Explanation](https://stackoverflow.com/questions/55012174/why-doesnt-object-keys-return-a-keyof-type-in-typescript)
- [TypeScript issues about this](https://github.com/microsoft/TypeScript/issues/45390)

@example
```
type SomeObject = { value: string } | { key: string };

const ob: SomeObject = Math.random() > 0.5 ? { value: 'Hello world' } : { key: 'the end' };
const unionKeys = objectKeysOfUnion(ob); // => ("value" | "key")[]
const typedKeys = objectKeys(ob); // => never[]
const untypedItems = Object.keys(ob); // => string[]
```
*/
export const objectKeysOfUnion = Object.keys as <T extends object>(value: T) => Array<KeysOfUnion<T>>;
